<template>
  <h2 class="content-heading">
    <slot></slot>
  </h2>
</template>

<script>
  export default {
    name: 'content-heading',
  };
</script>


// WEBPACK FOOTER //
// src/components/content-heading/index.vue